	<!-- User Info Card -->

	<div class="col-12 col-md-12">
		<div class="card h-100">
			<div class="card-body">
				<h5 class="card-title">{{contentStrings['MyResidence'][language]}}</h5>
				<div>
					<div class="listSection">
						<div class="listItemDiv">
							<span>
								{{contentStrings['Name'][language]}}:
							</span>
							<span>
								{{ userService.currentTennant()?.First_name }} {{ userService.currentTennant()?.Last_name }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								{{contentStrings['Phone'][language]}}:
							</span>
							<span>
								{{ userService.currentTennant()?.Phone }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								{{contentStrings['Email'][language]}}:
							</span>
							<span>
								{{ userService.currentTennant()?.Email }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								{{contentStrings['UnitNo'][language]}}:
							</span>
							<span>
								{{ userService.currentTennant()?.Unit_number }}
							</span>
						</div>
					</div>

					<div class="listSection">
						<div class="listItemDiv">
							<span>
								{{contentStrings['Address'][language]}}:
							</span>
							<span>
								{{ userService.currentTennant()?.Street_address }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								{{contentStrings['City'][language]}}:
							</span>
							<span>
								{{ userService.currentTennant()?.City }}
							</span>
						</div>
						<div class="listItemDiv">
							<span>
								{{contentStrings['Region'][language]}}:
							</span>
							<span>
								{{ userService.currentTennant()?.Region }}
							</span>
						</div>
					</div>

					<div>
						<iframe class="iframer" *ngIf="safeMapUrl" [src]="safeMapUrl" width="100%" height="300" style="border:0;" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade">
						</iframe>
					</div>
				</div>

			</div>
		</div>
	</div>
	<!--
	<div class="col-12 col-md-4">
		<div class="card h-100">
			<div class="card-body">
				<h5 class="card-title">Community Calendar</h5>
				<div>
					<app-community-calendar></app-community-calendar>
				</div>
			</div>
		</div>
	</div>
	<div class="col-12 col-md-5">
		<app-payments-overview>	</app-payments-overview>
	</div>
	-->

